<template>
  <div>
    <div class="card">
      <div class="card-header">
        <div class="row">
          <div class="col">
            <h5 class="card-title">Anlagen verwalten</h5>
          </div>
          <div class="col-md-auto text-right">
            <p-button type="success" @click="createAnlage" class="mt-0"><i class="bi bi-file-earmark-plus"></i> Neue Anlage</p-button>
          </div>
        </div>
      </div>
      <div class="card-body row">
        <div class="col-sm-12">
          <el-table :data="anlagen" border style="width: 100%">
            <el-table-column prop="name" label="Name" min-width="160"></el-table-column>
            <el-table-column label="Adresse" min-width="260">
              <template slot-scope="scope">
                <span>{{ scope.row.street }}, {{ scope.row.zip }} {{ scope.row.city }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="baujahr" label="Baujahr" width="120"></el-table-column>
            <el-table-column prop="modell" label="Modell" min-width="160"></el-table-column>
            <el-table-column label="Aktionen" width="160" fixed="right">
              <template slot-scope="scope">
                <el-tooltip content="Bearbeiten" placement="top">
                  <p-button size="sm" class="my-1 px-1" icon @click="editAnlage(scope.row)">
                    <i class="fa fa-edit"></i>
                  </p-button>
                </el-tooltip>
                <el-tooltip content="Löschen" placement="top">
                  <p-button type="danger" size="sm" class="my-1 px-1" icon @click="removeAnlage(scope.row)">
                    <i class="fa fa-trash"></i>
                  </p-button>
                </el-tooltip>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>

    <!-- NEW Modal -->
    <el-dialog :title="dialogTitle" :visible.sync="newDialog" :close-on-click-modal="false">
      <el-form ref="anlageForm" :model="newAnlage" :rules="rules" label-position="top">
        <div class="row">
          <div class="col-md-6 pb-2">
            <el-form-item label="Name" prop="name">
              <el-input v-model="newAnlage.name" placeholder="Name der Anlage"></el-input>
            </el-form-item>
          </div>
          <div class="col-md-6 pb-2">
            <el-form-item label="Modell" prop="modell">
              <el-input v-model="newAnlage.modell" placeholder="Modellbezeichnung"></el-input>
            </el-form-item>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6 pb-2">
            <el-form-item label="Straße" prop="street">
              <el-input v-model="newAnlage.street" placeholder="Straße und Hausnummer"></el-input>
            </el-form-item>
          </div>
          <div class="col-md-3 pb-2">
            <el-form-item label="Postleitzahl" prop="zip">
              <el-input v-model="newAnlage.zip" placeholder="PLZ"></el-input>
            </el-form-item>
          </div>
          <div class="col-md-3 pb-2">
            <el-form-item label="Ort" prop="city">
              <el-input v-model="newAnlage.city" placeholder="Ort"></el-input>
            </el-form-item>
          </div>
        </div>
        <div class="row">
          <div class="col-md-3 pb-2">
            <el-form-item label="Baujahr" prop="baujahr">
              <el-input-number v-model="newAnlage.baujahr" :min="2000" :max="2100" class="w-100"></el-input-number>
            </el-form-item>
          </div>
          <div class="col-md-9 pb-2">
            <el-form-item label="Kürzel" prop="locationId">
              <el-input v-model="newAnlage.locationId" placeholder="Kürzel"></el-input>
            </el-form-item>
          </div>
        </div>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <p-button @click="newDialog = false">Abbrechen</p-button>
        <p-button type="primary" :loading="saving" @click="add">Speichern</p-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import Vue from "vue";
import { db } from "../../../../firebaseDb";
import { Table, TableColumn, Tooltip, Select, Option, Input, InputNumber, Collapse, CollapseItem, MessageBox, Dialog, Form, FormItem } from "element-ui";
import router from "../../../../main";
import moment from "moment-timezone";
import store from "../../../../store";
Vue.use(Table);
Vue.use(TableColumn);
Vue.use(Tooltip);

export default {
  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    [Input.name]: Input,
    [InputNumber.name]: InputNumber,
    [Collapse.name]: Collapse,
    [CollapseItem.name]: CollapseItem,
    MessageBox,
    [Dialog.name]: Dialog,
    [Form.name]: Form,
    [FormItem.name]: FormItem,
  },

  data() {
    return {
      anlagen: [],
      newDialog: false,
      dialogMode: 'new',
      dialogTitle: 'Neue Anlage',
      saving: false,
      newAnlage: {
        name: '',
        street: '',
        zip: '',
        city: '',
        baujahr: null,
        locationId: store.getters.userlocation || '',
        modell: '',
      },
      rules: {
        name: [{ required: true, message: 'Bitte Namen angeben', trigger: 'blur' }],
        street: [{ required: false, message: 'Bitte Straße angeben', trigger: 'blur' }],
        zip: [{ required: false, message: 'Bitte PLZ angeben', trigger: 'blur' }],
        city: [{ required: false, message: 'Bitte Ort angeben', trigger: 'blur' }],
        baujahr: [{ required: false, message: 'Bitte Baujahr angeben', trigger: 'change' }],
        locationId: [{ required: true, message: 'Bitte Kürzel angeben', trigger: 'blur' }],
        modell: [{ required: false, message: 'Bitte Modell angeben', trigger: 'blur' }],
      },
      location: store.getters.userlocation,
      role: store.getters.userrole,
      pickerOptions1: {
        firstDayOfWeek: 1,
        shortcuts: [
          {
            text: "Morgen",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() + 3600 * 1000 * 24);
              picker.$emit("pick", date);
            },
          },
          {
            text: "In 1 Woche",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() + 3600 * 1000 * 24 * 7);
              picker.$emit("pick", date);
            },
          },
          {
            text: "In 2 Wochen",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() + 3600 * 1000 * 24 * 14);
              picker.$emit("pick", date);
            },
          },
          {
            text: "In 1 Monat",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() + 3600 * 1000 * 24 * 30);
              picker.$emit("pick", date);
            },
          },
        ],
      },
    };
  },
  created() {
    this.load();
    store.watch(
      (state) => state.userlocation,
      () => {
        this.location = store.getters.userlocation;
        this.load();
      }
    );
  },
  methods: {
    load() {
      const ref = db.collection('anlagen');
        ref.onSnapshot((qs) => {
          this.anlagen = [];
          qs.forEach((doc) => {
            const d = doc.data();
            this.anlagen.push({
              key: doc.id,
              name: d.name || '',
              street: d.street || '',
              zip: d.zip || '',
              city: d.city || '',
              baujahr: d.baujahr || null,
              locationId: d.locationId || '',
              modell: d.modell || '',
            });
          });
        });

    },
    createAnlage() {
      this.dialogMode = 'new';
      this.dialogTitle = 'Neue Anlage';
      this.newAnlage = {
        name: '',
        street: '',
        zip: '',
        city: '',
        baujahr: null,
        locationId: '',
        modell: '',
      };
      this.newDialog = true;
    },
    editAnlage(row) {
      this.dialogMode = 'edit';
      this.dialogTitle = 'Anlage bearbeiten';
      this.newAnlage = {
        name: row.name,
        street: row.street,
        zip: row.zip,
        city: row.city,
        baujahr: row.baujahr,
        locationId: row.locationId,
        modell: row.modell,
        key: row.key,
      };
      this.newDialog = true;
    },
    removeAnlage(row) {
      MessageBox.confirm(
        'Soll die Anlage "' + row.name + '" gelöscht werden?',
        'Warnung',
        {
          confirmButtonText: 'Löschen',
          cancelButtonText: 'Abbrechen',
          type: 'warning',
          callback: (action) => {
            if (action === 'confirm') {
              db.collection('anlagen').doc(row.key).delete().then(() => {
                console.log('Anlage gelöscht');
              }).catch((err) => {
                console.log('Fehler beim Löschen', err);
              });
            }
          },
        }
      );
    },
    add() {
      this.$refs.anlageForm.validate((valid) => {
        if (!valid) return;
        this.saving = true;
        const payload = {
          name: this.newAnlage.name,
          street: this.newAnlage.street,
          zip: this.newAnlage.zip,
          city: this.newAnlage.city,
          baujahr: this.newAnlage.baujahr,
          locationId: this.newAnlage.locationId,
          modell: this.newAnlage.modell,
        };
        if (this.dialogMode === 'edit' && this.newAnlage.key) {
          db.collection('anlagen').doc(this.newAnlage.key).update(payload).then(() => {
            this.saving = false;
            this.newDialog = false;
          }).catch((err) => {
            this.saving = false;
            console.log('Fehler beim Aktualisieren', err);
          });
        } else {
          db.collection('anlagen').add(payload).then(() => {
            this.saving = false;
            this.newDialog = false;
          }).catch((err) => {
            this.saving = false;
            console.log('Fehler beim Speichern', err);
          });
        }
      });
    },
  },
};
</script>
<style>
  .el-form-item__label {
    font-weight: bold;
    line-height: normal !important;
  }
</style>
